var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 26,
    viewBox: "0 0 31 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9722_2272)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.708 25.4004L14.5908 22.2832L22.3633 14.5518H0.00976562V10.1836H22.3633L14.5908 2.45215L17.708 -0.665039L30.7305 12.3779L17.708 25.4004Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9722_2272"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 31,
    height: 26,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTo);
export default __webpack_public_path__ + "static/media/to.95c88bf4685b8e84b175eb863b3a4886.svg";
export { ForwardRef as ReactComponent };